module.exports = __webpack_public_path__ + "static/site-1784739815621/img/asset_fiscal.a3ed015d.png";